import React from "react";
import { useNavigate } from "react-router-dom";
import { SecondaryButton } from "@/components/ds";
import UpgradePrompt from "@/components/ds/UpgradePrompt";

interface Props {
  name: string;
  description?: string;
  plan?: "Professional" | "Enterprise" | "Add-on";
  benefits?: string[];
}

/**
 * Shown when a user navigates to an integration config page
 * but their subscription doesn't include that integration.
 * Shows upgrade benefits and a clear CTA instead of just "contact us".
 */
export default function IntegrationNotEnabled({
  name,
  description,
  plan,
  benefits
}: Props) {
  const navigate = useNavigate();

  return (
    <div>
      <UpgradePrompt
        featureName={name}
        plan={plan ?? "Professional"}
        description={description}
        benefits={benefits}
        subject={`Enable ${name} integration`}
      />
      <div className="flex justify-center mt-2">
        <SecondaryButton onClick={() => navigate("/integrations")}>
          Back to Integrations
        </SecondaryButton>
      </div>
    </div>
  );
}
